import { formatDistance } from "date-fns";

export const getTimeAgo = (date: string, addSuffix = true) =>
  formatDistance(new Date(date), new Date(), {
    addSuffix,
  });
